<div [ngStyle]="{'display': showField ? 'block' : 'none'}">
  <textarea class="amp-markdown-editor" name="contentField" ngDefaultControl #contentField="ngModel" #mdeField [(ngModel)]="content" id="my-text-area"></textarea>
</div>

<div [ngStyle]="{'display': showField ? 'none' : 'block'}">
  <showdown class="amp-markdown" [value]="content"></showdown>
</div>